// extracted by mini-css-extract-plugin
export default {"root":"zpIv9wT0TZ","name":"gvhd2sW7GY","name_small":"DLr3YcwLGC","identifiesAs":"Q55LshxpeW"};